import React, { useState } from "react";
import { Dialog, Table } from "../../../../../layout";
import Header from "./Header";
import { Grid } from "@mui/material";
import TableProdWidget from "./TableProdWidget";
import ViewProd from "../../../../Catalog/Product/ViewProduct/ViewProd";
import { useFormatPrice } from "hooks";

const Products = ({ value, setQuotes, handleClose, handleContinuSale }) => {
  const formatPrice = useFormatPrice();
  const [showDetails, setShowDetails] = useState(false);
  const [viewProdId, setViewProdId] = useState();

  const handleView = (val) => {
    setShowDetails(!showDetails);
    setViewProdId(val.prodId);
  };

  return (
    <>
      <Grid item xs={12}>
        {value && value.quoteItems && (
          <Table
            ActionComp={() => <></>}
            HeaderComp={() => (
              <Header
                {...{ value, setQuotes, handleClose, handleContinuSale }}
              />
            )}
            tblHead={[
              { id: "product", label: "Product" },
              { id: "qty", label: "Qty" },
              { id: "price", label: "Price" },
              { id: "total", label: "Total" },
            ]}
            tblData={value.quoteItems.map((item) => {
              return {
                ...item,
                searchTerm: item.prod
                  ? `${item.prod.name} ${item.prod.skuCode}`
                  : "",
                product: (
                  <TableProdWidget
                    {...{
                      handleView,
                      item,
                      discount: item.discount
                        ? `Discount: ${formatPrice(item.disAmt)}`
                        : "",
                    }}
                  />
                ),
                price: (
                  <div className="flex flex-col">
                    <span className="text-[16px]">
                      {formatPrice(item.price - (item.disAmt || 0))}
                    </span>
                    {item.disAmt > 0 && (
                      <span className="text-[14px] line-through">
                        {formatPrice(item.price)}
                      </span>
                    )}
                  </div>
                ),
                total: (
                  <span className="text-[18px]">
                    {formatPrice(item.qty * (item.price - (item.disAmt || 0)))}
                  </span>
                ),
              };
            })}
          />
        )}
      </Grid>

      {/* View Product */}
      {showDetails && (
        <Dialog show={showDetails} onClose={false} maxWidth="lg">
          <ViewProd {...{ setShowForm: setShowDetails, id: viewProdId }} />
        </Dialog>
      )}
    </>
  );
};

export default Products;
